import React, {Component} from 'react';
import axios from "../../axios-cmk";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import {connect} from "react-redux";
import {Col, Container, FormGroup, Input, Row, Table} from "reactstrap";
import {loadVisitsReportData, setVisitsIdsForReports} from "../../store/actions";
import FontAwesome from 'react-fontawesome';
import './Reports.css'
import moment from "moment/moment";
import ReportToolbox from "./ReportToolbox/ReportToolbox";

class VisitsReport extends Component {

    state = {
        patientFilter: '',
        therapistFilter: '',
        statusFilter: '',
    };

    onPatientFilterChange = (event) => {
        this.setState({
            patientFilter: event.target.value
        })
    };

    onStatusFilterChange = (event) => {
        this.setState({
            statusFilter: event.target.value
        })
    };

    onTherapistFilterChange = (event) => {
        this.setState({
            therapistFilter: event.target.value
        })
    };

    componentDidMount() {
        this.props.loadData(this.props.reports_period.value)
    }

    visitIsSelected = (visit) => {
        return this.props.selected_visit_ids.includes(visit.id)
    }

    onVisitCheck = (visit, event) => {
        if (this.props.selected_visit_ids.includes(visit.id)) {
            this.props.setVisitsIdsForReports(this.props.selected_visit_ids.map(v=>v!==visit.id))
        } else {
            this.props.setVisitsIdsForReports([...this.props.selected_visit_ids,visit.id])
        }
        //this.forceUpdate()
    };


    render() {
        const patient_data_rows = this.props.visits_report_data.reports.filter((visit) => {

            if (this.visitIsSelected(visit)) return visit;

            if (this.state.patientFilter !== '') {
                if (visit.patient!=null && visit.patient.label.toLowerCase().indexOf(this.state.patientFilter.toLowerCase()) >= 0) {
                    return visit
                }
            } else {
                return visit
            }
            return null

        }).filter((visit) => {

            if (this.visitIsSelected(visit)) return visit;

            if (this.state.therapistFilter !== '') {
                if (visit.therapist.label.toLowerCase().indexOf(this.state.therapistFilter.toLowerCase()) >= 0) {
                    return visit
                }
            } else {
                return visit
            }
            return null
        }).filter((visit) => {

            if (this.visitIsSelected(visit)) return visit;

            if (this.state.statusFilter !== '') {
                if (visit.status_label.toLowerCase().indexOf(this.state.statusFilter.toLowerCase()) >= 0) {
                    return visit
                }
            } else {
                return visit
            }
            return null
        }).map((visit, index) => {
            const day_name = moment(visit.date).format('ddd');
            const checkbox_visit_id = "check_visit_" + visit.id;
            const class_name = "row_"+visit.status;
            const ch_checked = this.props.selected_visit_ids.includes(visit.id)?'checked':'';
            const visit_number = this.props.action_bar_opened ? (
                <FormGroup check>
                    <Input
                        type="checkbox"
                        id={checkbox_visit_id}
                        onChange={(event) => this.onVisitCheck(visit, event)}
                        checked={ch_checked}
                    /> {index + 1}
                </FormGroup>
            ) : (index + 1);
            return (
                <tr key={visit.id} className="visitRow">
                    <th className="visitNumber">{visit_number}</th>
                    <td>{day_name}, {visit.date} godz. {visit.formatted_hour_start}</td>
                    <td>{visit.patient.label}</td>
                    <td>{visit.therapist.first_name} {visit.therapist.last_name}</td>
                    <td>{visit.duration_hours}</td>
                    <td className={class_name}>{visit.status_label}</td>
                </tr>
            )
        });
        return (
            <Container fluid>
                <Row className="print-only">
                    <Col>
                        <h2>Kalendarz wizyt na {this.props.reports_period.label}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Table striped>
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>Data</th>
                                <th>Pacjent</th>
                                <th>Terapeuta</th>
                                <th>Czas trwania [h]</th>
                                <th>Status</th>
                            </tr>
                            <tr className="no-print">
                                <th colSpan={2}>
                                    <ReportToolbox/>
                                </th>
                                <th>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FontAwesome
                                                name='filter'/></span>
                                        </div>
                                        <input type="text" className="form-control" placeholder="Filtruj pacjentów"
                                               aria-describedby="basic-addon1"
                                               onChange={this.onPatientFilterChange}/>
                                    </div>
                                </th>
                                <th>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon2"><FontAwesome
                                                name='filter'/></span>
                                        </div>
                                        <input type="text" className="form-control" placeholder="Filtruj terapeutów"
                                               aria-describedby="basic-addon2"
                                               onChange={this.onTherapistFilterChange}/>
                                    </div>
                                </th>
                                <th></th>
                                <th>
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon3"><FontAwesome
                                                name='filter'/></span>
                                        </div>
                                        <input type="text" className="form-control" placeholder="Filtruj status"
                                               aria-describedby="basic-addon3"
                                               onChange={this.onStatusFilterChange}/>
                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {patient_data_rows}
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Container>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadData: (period) => dispatch(loadVisitsReportData(period)),
        setVisitsIdsForReports: (visit_ids) => dispatch(setVisitsIdsForReports(visit_ids))
    }
}

const mapStateToProps = state => {
    return {
        reports_period: state.reports.reports_period,
        visits_report_data: state.reports.visits_report_data,
        action_bar_opened: state.reports.action_bar_opened,
        selected_visit_ids: state.reports.selected_visit_ids,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(VisitsReport, axios));



// WEBPACK FOOTER //
// ./src/components/Reports/VisitsReport.js